// @flow
import * as React from 'react';
import { Box, Button } from 'gestalt';

type Props = {
  onClick: () => void,
  text: string,
};

const ConnectButton = ({ onClick, text }: Props) => (
  <Box marginStart={2}>
    <Button color="transparent" inline onClick={onClick} text={text} />
  </Box>
);

export default ConnectButton;
